<template>
  <div id="attendanceMonitoring" style="padding: 0 20px; background: white; min-height: 80vh" class="p-4">
    <K2Empty v-if="!currentSchoolHex" />
    <div v-else>
      <K2Text font-size="13px" align="left" class="w-100 d-block k2Tag mb-2"> **Only allow for internal network </K2Text>
      <Academica :url="url" />
    </div>
  </div>
</template>
<script>
import uiVariable from '../../config/uiVariable'
import { lang } from '../../locale'
import Academica from '../academica/Academica'
import { getCurrentSchool } from '@/helper/util_custom'
import configAdmin from '../../config/configAdmin'
import K2Empty from '../../uiComponents/k2Empty/k2Empty'
import K2Text from '../../uiComponents/k2Text/k2Text'

export default {
  name: 'AttendanceMonitoring',
  components: { K2Text, K2Empty, Academica },
  data() {
    return {
      uiVariable: uiVariable,
      url: '',
      currentSchoolHex: '',
    }
  },
  mounted() {
    let school = getCurrentSchool()
    let currentSchoolHex = configAdmin.schoolHex?.find(d => d.school === school)
    this.currentSchoolHex = currentSchoolHex
    this.url =
      'https://bi-server.etonhouse.com/?wsId=6689936e-97ed-4c15-a0eb-63d2f63e1b38&rptId=0e2a788e-416b-4f6a-ab8c-909a246dd7a0&sch=' + currentSchoolHex?.hex
  },
  methods: {
    lang,
  },
}
</script>
